import { render, staticRenderFns } from "./ListChannels.vue?vue&type=template&id=12d96a64&scoped=true&"
import script from "./ListChannels.vue?vue&type=script&lang=ts&"
export * from "./ListChannels.vue?vue&type=script&lang=ts&"
import style0 from "./ListChannels.vue?vue&type=style&index=0&id=12d96a64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d96a64",
  null
  
)

export default component.exports